import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import {
  MergeRequestRow,
  MergeRequestsTable,
} from '@/features/admin/account-linking/components/MergeRequestsTable'
import { type AccountMergeRequestItemViewModel } from '@/features/admin/account-linking/AccountMergeRequestItemViewModel'
import { type AccountMergeRequestsViewModel } from '@/features/admin/account-linking/AccountMergeRequestsViewModel'

export interface MergeRequestsTableContainerProps {
  vm: AccountMergeRequestsViewModel
}

export const MergeRequestsTableContainer = observer(
  function MergeRequestsTableContainer({
    vm,
  }: MergeRequestsTableContainerProps) {
    return (
      <MergeRequestsTable
        searchText={vm.searcher.searchText.value}
        onSearchTextChange={vm.searcher.searchText.change}
        statusOrActions={vm.searcher.statusOrActions}
        loader={
          !vm.searcher.scrollProvider.isDone && (
            <InfiniteScrollLoaderContainer
              scrollProvider={vm.searcher.scrollProvider}
            />
          )
        }
      >
        {vm.searcher.mergeRequests.map((itemVm) => (
          <MergeRequestRowContainer key={itemVm.id} itemVm={itemVm} />
        ))}
      </MergeRequestsTable>
    )
  },
)

interface MergeRequestRowContainerProps {
  itemVm: AccountMergeRequestItemViewModel
}

const MergeRequestRowContainer = observer(function MergeRequestRowContainer({
  itemVm,
}: MergeRequestRowContainerProps) {
  return (
    <MergeRequestRow
      hubspotLink={itemVm.hubspotLink}
      displayName={itemVm.displayName}
      avatar={itemVm.avatar}
      avatarFallback={itemVm.avatarFallback}
      email={itemVm.email}
      primaryAccountId={itemVm.primaryAccountId}
      duplicateAccountId={itemVm.duplicateAccountId}
      dateCreated={itemVm.dateCreated}
      statusOrActions={itemVm.statusOrActions}
      displayStatus={itemVm.displayStatus}
      onMerge={itemVm.merge}
      onReject={itemVm.reject}
      onIgnore={itemVm.ignore}
    />
  )
})
